"use client";

import { createContext, useContext } from "react";
const PropValuesContext = createContext<Record<string, unknown> | undefined>(undefined);
export const PropValuesProvider = PropValuesContext.Provider;
export function usePropValues() {
  return useContext(PropValuesContext);
}